import React, { Component, PropsWithChildren } from 'react';

interface IProps extends PropsWithChildren<{}> {}
export default class DialogBody extends Component<IProps> {
    public render() {
        return <div className="dialog-body">{this.props.children}</div>;
    }
}
